// extracted by mini-css-extract-plugin
module.exports = {"root":"PaginatedStream__root--37Tre"};